import React, { useState, useCallback, useEffect, useRef } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import List from "../../../../../listing/components/list";
import { fetchPointsProductList } from "../../../../../../../api";
import { FormattedMessage } from "react-intl";

export default props =>{
    useStyles(cls);
    const { customer } = props;
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [finished, setFinished] = useState(false);
    const skipRef = useRef(0);

    useEffect(async () =>{
        loadHandle();
    },[]);

    const loadHandle = useCallback(async () =>{
        setLoading(true);
        let products = await fetchPointsProductList({skip:skipRef.current, limit:20, type:0, code:"APP0010"}).then(response=>{
            const productItems = response?.result?.map(p => ({
                ...p,
                geekoRequsestId: response.requestId,
                geekoExperimentId: response.experimentId,
                layerName: response.layerName,
                trackingRecords: response.trackingRecords
            }))
            return productItems || [];
        }).catch(error=>[])
        setProducts(preValue => [...preValue, ...products]);
        skipRef.current += 20;
        setLoading(false)
        setFinished(!!!products || products?.length < 20);
    }, [])

    return <div className={cls.PointsRecommend}>
        <div className={cls.Title}><FormattedMessage id="apply_points" defaultMessage="Apply points towards purchase" /></div>

        <div className={cls.List}>
        <List 
            request={loadHandle} 
            loading={loading} 
            finished={finished} 
            products={products}
            ingoreCard
        />
        </div>
    </div>
}